import { AnyAction } from "@reduxjs/toolkit";
import { createContext } from "react";
import { CartContextType } from "./CartContext";

export const Context = createContext<
  [CartContextType, React.Dispatch<AnyAction>] | undefined
>(undefined);
